var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "mLaunch",
    class: _vm.isMobile && 'wap'
  }, [_c('div', {
    staticClass: "mLaunch-content"
  }, [_vm.feeBoxShow ? _c('div', {
    staticClass: "mLaunch-item"
  }, [_c('div', {
    staticClass: "mLaunch-item__title"
  }, [_vm._v("Marketing Fee")]), _c('div', {
    staticClass: "mLaunch-item__price"
  }, [_vm._v(_vm._s(_vm.fmt_pre(_vm.ethFee, 5)) + " " + _vm._s(_vm.web3Wallet.symbol))]), _c('div', {
    staticClass: "mLaunch-btns"
  }, [!_vm.loading ? [_c('div', {
    staticClass: "btn-collect",
    on: {
      "click": _vm.collectFee
    }
  }, [_vm.isCollectLoading ? _c('div', {
    staticClass: "btnLoading"
  }) : _c('span', [_vm._v("Claim")])])] : [_c('div', {
    staticClass: "btnLoading"
  })]], 2)]) : _vm.leaderBoxShow ? _c('div', {
    staticClass: "mLaunch-item"
  }, [_c('div', {
    staticClass: "mLaunch-item__title"
  }, [_vm._v("Marketing Fee")]), _c('div', {
    staticClass: "mLaunch-item__price"
  }, [_vm._v(_vm._s(_vm.fmt_pre(_vm.leaderFee, 5)) + " " + _vm._s(_vm.web3Wallet.symbol))]), _c('div', {
    staticClass: "mLaunch-btns"
  }, [_vm.userInfo ? [!_vm.loading && _vm.tokenData ? [_vm.userInfo.twitter && _vm.tokenData.leader_twitter && _vm.tokenData.leader_twitter === _vm.userInfo.twitter ? [_vm.leaderAddress !== _vm.web3Wallet.address ? _c('div', {
    staticClass: "btn-collect",
    on: {
      "click": function ($event) {
        return _vm.callChangeLeader();
      }
    }
  }, [_vm.isTwitterClaimLoading ? _c('div', {
    staticClass: "btnLoading"
  }) : _c('span', [_vm._v("Claim")])]) : _vm._e()] : _c('div', {
    staticClass: "btn-collect",
    on: {
      "click": _vm.getTwitterAuthUrl
    }
  }, [_vm.isTwitterAuthorizeLoading ? _c('div', {
    staticClass: "btnLoading"
  }) : _c('span', [_vm._v("@" + _vm._s(_vm.tokenData.leader_twitter) + " Twitter authorize")])])] : [_c('div', {
    staticClass: "btnLoading"
  })]] : [_c('div', {
    staticClass: "btn-collect",
    on: {
      "click": _vm.doConnect
    }
  }, [_vm._v("@" + _vm._s(_vm.tokenData.leader_twitter) + " Twitter authorize")])]], 2)]) : _vm._e()])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };